<template>
  <div :id="tblName">
    <div class="table-responsive tableFixHead">

    <label class="d-none d-print-block"><b>{{title}}</b></label>
      <table class="table table-bordered table-sm fs-15" :class="tblName" :style="'min-height:'+ tblHeight">
        <thead>
          <tr>
            <th v-for="column in columns" :key="column.name" v-if="column.show && column.name!=='action'" @click="$emit('sort', column.name)" class="nowrap" :class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'" 
              :style="'width:'+column.width+';'+'cursor:pointer; min-width: 80px;'">
              <span class="mr-2">{{column.label}}</span>
            </th>
            <slot name="th"></slot>
          </tr>
          <slot name="filter"></slot>
        </thead>
        <slot name="tbody"></slot>
      </table>
      <slot name="tfooter"></slot>
    </div>

    <hr class="d-print-none">

    <!-- Viewing on md+ screen -->
    <div class="d-none d-sm-block d-print-none">
      <div class="row">
        <div class="col-4">
            <slot name="rows"></slot>
        </div>
        <div class="col-8">
          <div class="float-right">

          
            <!-- <span>Rows per page:</span>
            <select :value="filterLength" @change="$emit('num_rows')" class="form-control custom-select-sm ml-1 mr-3" style="width: 65px !important;">
              <option v-for="(records, index) in perPage" :key="index" :value="records">{{records}}</option>
            </select> -->
              <span class="ml-3 mr-1">Showing {{pagination.from}} to {{pagination.to}} of {{pagination.total}} entries</span>
              <button v-if="pagination.prevPageUrl" class="btn  btn-outline-primary btn-sm" @click="$emit('prev');">
                <i class="fas fa-chevron-left"></i>
              </button>
              <button class="btn  btn-outline-primary btn-sm" v-else :disabled="true">
                <i class="fas fa-chevron-left"></i>
              </button>

              <button v-if="pagination.nextPageUrl" class="btn  btn-outline-primary btn-sm" @click="$emit('next');">
                <i class="fas fa-chevron-right"></i>
              </button>
              <button class="btn  btn-outline-primary btn-sm" v-else :disabled="true">
                <i class="fas fa-chevron-right"></i>
              </button>
          </div>
        </div>
      </div>
    </div>


    <!-- Viewing on xs, sm screen -->
    <div class="d-block d-sm-none d-print-none">
      <div class="row">
        <div class="col-4">
          <!-- <button type="button" class="btn btn-outline-primary btn-sm"><i class="fas fa-sync mr-1"></i>Refresh</button> -->
        </div>

        <div class="col-8">
          <div class="float-right">

          <slot name="rows"></slot>

            <!-- <span>Rows per page:</span>
            <select :value="filterLength" @change="$emit('num_rows')" class="form-control custom-select-sm ml-1" style="width: 50px !important;">
              <option v-for="range in perPage" :value="range">{{range}}</option>
            </select> -->
          </div>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-12">
          <div class="float-right">
            <span class="mr-1">Showing {{pag_from}} to {{pag_to}} of {{pag_total}} entries</span>
            <button v-if="pagination.prevPageUrl" class="btn  btn-outline-primary btn-sm" @click="$emit('prev');">
              <i class="fas fa-chevron-left"></i>
            </button>
            <button class="btn  btn-outline-primary btn-sm" v-else :disabled="true">
              <i class="fas fa-chevron-left"></i>
            </button>

            <button v-if="pagination.nextPageUrl" class="btn  btn-outline-primary btn-sm" @click="$emit('next');">
              <i class="fas fa-chevron-right"></i>
            </button>
            <button class="btn  btn-outline-primary btn-sm" v-else :disabled="true">
              <i class="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
  export default {
    props: ['columns', 'sortKey', 'sortOrders', 'pagination', 'tblName', 'title', 'tblHeight'],

    computed:{
      pag_from(){
        let x = this.pagination.from;
        return x ? x : 0;
      },
      pag_to(){
        let x = this.pagination.to;
        return x ? x : 0;
      },
      pag_total(){
        let x = this.pagination.total;
        return x ? x : 0;
      }
    },
  }
</script>